import NiceModal from '@ebay/nice-modal-react';

import type {ConferenceType, Strategy} from './types';

import {logger} from '../../utils/logger';
import {conferenceStopHandler} from '../conference';
import {BookConferenceModal} from './modals/BookConference';
import {BookConferenceTypePicker} from './modals/BookConferenceTypePicker';

type Props = {
  conferenceDuration: number;
  conferenceToRescheduleId?: string;
  courseId: string;
  onBook?: () => void;
  place: string;
  strategy?: Strategy;
};

export const runBookConferenceFlow = async (props: Props) => {
  const {
    conferenceDuration,
    conferenceToRescheduleId,
    courseId,
    onBook,
    place,
    strategy,
  } = props;

  logger.event('session_schedule_open_tap', {
    place,
  });

  const conferenceType: ConferenceType | undefined = await NiceModal.show(
    BookConferenceTypePicker,
    {
      duration: conferenceDuration,
    },
  );

  const onCancel = () => {
    conferenceStopHandler.requestConferenceFeedbackIfNeeded();
  };

  if (!conferenceType) {
    onCancel();

    return;
  }

  await NiceModal.show(BookConferenceModal, {
    conferenceToRescheduleId,
    conferenceType,
    courseId,
    onBook: () => {
      NiceModal.hide(BookConferenceModal);
      conferenceStopHandler.requestConferenceFeedbackIfNeeded();
      onBook?.();
    },
    onCancel,
    strategy,
  });
};
